import React, { Component } from 'react';
import { connect } from 'react-redux';
import Axios from 'axios';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import hasPath from 'lodash/has';
import { RadioGroup, ReversedRadioButton } from 'react-radio-buttons';
import Dropzone from 'react-dropzone';
import 'react-toggle/style.css';
import { Player, ControlBar, PlayToggle, BigPlayButton } from 'video-react';
import CompactPicker from 'react-color/lib/Compact';

import Colors from '../styles/colors';
import commonStyles from '../styles/commonStyles';
import { BaseButton } from '../styles/styled';
import { emailValidator } from '../helpers/validators';
import { SoundwiseHeader } from '../components/soundwise_header';
import Footer from '../components/footer';
import Loading from '../components/Loading';
const { isFreeAccount, canPublisherAccessFeature } = require('../../server/scripts/utils.js')();

window.URL = window.URL || window.webkitURL;
class _WaveVideoInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signedIn: false,
      playing: false,
      audioName: null,
      audioFile: null,
      imageFile: null,
      imageShape: 'square',
      wavePosition: 'bottom',
      waveColor: '#333',
      email: '',
      submitted: false,
      processingUrl: 'https://app.mysoundwise.com:8080/api/soundwave',
    };

    this.handleStateChange = this.handleStateChange.bind(this);
    this.onAudioDrop = this.onAudioDrop.bind(this);
    this.onImageDrop = this.onImageDrop.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    // subscribe state change
    this.refs.player.subscribeToStateChange(this.handleStateChange);
    window.addEventListener(
      'dragover',
      function(e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );
    window.addEventListener(
      'drop',
      function(e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );
    if (this.props.isLoggedIn && this.props.userInfo && this.props.userInfo.email) {
      this.setState({ email: this.props.userInfo.email[0] });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn && nextProps.userInfo && nextProps.userInfo.email) {
      this.setState({ email: nextProps.userInfo.email[0] });
    }
  }

  handleStateChange(state) {
    // copy player state to this component's state
    this.setState({ playing: state.hasStarted });
  }

  onAudioDrop([file]) {
    let { processingUrl } = this.state;
    if (file) {
      this.setState({
        processingUrl,
        audioFile: file,
        audioName: file.name,
        error: '',
      });
    } else {
      alert('Please upload a valid .mp3 or .m4a file!');
    }
  }

  onImageDrop([file]) {
    this.setState({
      imageFile: file,
      error: '',
    }, () => {
      // set image right away, no more cropping
      if (file && 'FileReader' in window) {
        const reader = new window.FileReader();
        reader.addEventListener('load', () => {
          setTimeout(() => {
            this.setState({
              cropResult: reader.result,
            });
          }, 500);
        }, false);

        reader.readAsDataURL(file);
      }
    });
  }

  isFeatureAccessible() {
    const { userInfo } = this.props;
    const { publisher = {} } = userInfo;
    return !isFreeAccount(userInfo)
      ? canPublisherAccessFeature(publisher, 'SOUNDWAVE_VIDEOS')
      : false;
  }


  submit() {
    const { audioFile, imageFile, wavePosition, waveColor, email, processingUrl } = this.state;
    if (!audioFile) {
      return alert('Please upload an audio clip before submitting!');
    }
    if (!imageFile) {
      return alert('Please upload an image before submitting!');
    }

    const { userInfo } = this.props;
    const { publisher = {} } = userInfo;
    const accessible = this.isFeatureAccessible();

    this.setState({ submitting: true });
    let data = new FormData();
    data.append('audio', audioFile, audioFile.name);
    data.append('image', imageFile, imageFile.name);
    data.append('color', waveColor);
    data.append('position', wavePosition);
    data.append('email', email);
    if (accessible) {
      data.append('publisherId', publisher.id);
    }

    Axios.post(processingUrl, data)
      .then(() => {
        this.setState({
          audioName: null,
          audioFile: null,
          imageFile: null,
          imageShape: 'square',
          cropResult: null,
          wavePosition: 'bottom',
          waveColor: '#333',
          email: null,
          submitting: false,
          submitted: true,
          error: false,
        });
      })
      .catch(err => {
        const error = hasPath(err, 'response.data.message')
          ? err.response.data.message
          : `Something went wrong when requesting data to server. ${err.message}`;

        this.setState({
          audioName: null,
          audioFile: null,
          imageFile: null,
          cropResult: null,
          imageShape: 'square',
          wavePosition: 'bottom',
          waveColor: '#333',
          email: null,
          submitted: false,
          submitting: false,
          error,
        });

        alert(error);
      });
  }

  renderSubmitButton() {
    const {
      email,
      audioFile,
      imageFile,
      wavePosition,
      waveColor,
      submitting,
      submitted,
      error,
    } = this.state;

    if (submitting) {
      return <Loading text="Submitting" align="center" fontSize={2}/>;
    }

    if (submitted && !error) {
      return (
        <React.Fragment>
          <div className="title-large">
            <strong>
              Your video inputs are submitted 🎉 We'll start working on it
              immediately!{' '}
            </strong>
          </div>
          <div className="title-small" style={{ marginTop: 15 }}>
            p.s. If you don't see an email from us in half an hour, please check your
            spam folder.
          </div>
        </React.Fragment>
      );
    }

    const isAllFieldsValid = [
      !isEmpty(audioFile),
      !isEmpty(imageFile),
      !isEmpty(wavePosition),
      !isEmpty(waveColor),
      emailValidator(email),
    ].every(field => field === true);

    return (
      <SubmitButton
        className="text-large font-weight-600"
        disabled={!isAllFieldsValid}
        onClick={this.submit}>
        Submit
      </SubmitButton>
    );
  }

  render() {
    const {
      audioName,
      wavePosition,
      waveColor,
    } = this.state;
    const { isLoggedIn } = this.props;
    const isFree = !this.isFeatureAccessible();

    return (
      <div>
        <Helmet>
          <title>{`${isFree ? 'Free ' : ''}Soundwave Video Maker`}</title>
          <meta property="og:url" content={`https://mysoundwise.com/wave_video`} />
          <meta property="fb:app_id" content="1726664310980105" />
          <meta
            property="og:title"
            content={`${isFree ? 'Free ' : ''}Soundwave Video Maker`}
          />
          <meta
            property="og:description"
            content={`Spice up social media sharing of your audios with a soundwave video clip generated from your audio recording.`}
          />
          <meta property="og:image" content="https://mysoundwise.com/images/vid-maker.png" />
          <meta
            name="description"
            content={`Spice up social media sharing of your audios with a soundwave video clip generated from your audio recording.`}
          />
          <meta
            name="keywords"
            content="soundwave video, audio clip, free video maker, audio course, podcast"
          />
          <meta
            name="twitter:title"
            content={`${isFree ? 'Free ' : ''}Soundwave Video Maker`}
          />
          <meta
            name="twitter:description"
            content={`Spice up social media sharing of your audios with a soundwave video clip generated from your audio recording.`}
          />
          <meta name="twitter:image" content="https://mysoundwise.com/images/vid-maker.png" />
          <meta name="twitter:card" content="https://mysoundwise.com/images/vid-maker.png" />
        </Helmet>
        <SoundwiseHeader showIcon={true} />
        <section
          className="no-padding xs-padding-50px-tb position-relative cover-background tz-builder-bg-image border-none hero-style9"
          id="hero-section11"
          data-img-size="(W)1920px X (H)800px"
          style={{
            background:
              "linear-gradient(-45deg,rgba(247,107,28,0.4), rgba(97,225,251,0.8)), url('images/mic_tv.jpg')",
            height: 600,
          }}
        >
          <div className="container position-relative" style={{ height: 600 }}>
            <div className="row">
              <div className="slider-typography xs-position-static text-center xs-padding-ten">
                <div className="slider-text-middle-main">
                  <div className="slider-text-middle text-left">
                    <div className="col-md-8 col-sm-10 col-xs-12 center-col text-center">
                      <h1 className="sm-title-extra-large-5 alt-font xs-title-extra-large-3 title-extra-large-5 line-height-75 text-white font-weight-700 letter-spacing-minus-2 tz-text margin-nine-bottom sm-margin-six-bottom margin-lr-auto">
                        {isFree ? 'Free ' : ''}Soundwave Video Maker
                      </h1>
                      <div className="text-white title-medium  xs-text-extra-large width-80 xs-width-90 margin-lr-auto tz-text">
                        <div>
                          Spice up social media sharing of your audio course and podcast with a
                          soundwave video clip generated from your audio recording.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="bg-white builder-bg padding-60px-tb xs-padding-60px-tb"
          id="video-section4"
        >
          <div className="container">
            <div className="row equalize xs-equalize-auto">
              <div
                className="col-lg-6 col-md-6 col-sm-6 col-xs-12 display-table xs-margin-fifteen-bottom"
                style={{}}
              >
                <div className="display-table-cell-vertical-middle" style={{}}>
                  <div className="col-xs-12 col-sm-12 col-md-10" style={{ paddingTop: 0 }}>
                    <Player ref="player" poster="/images/vid-demo.png" aspectRatio="1:1">
                      <source src="https://soundwiseinc.s3.amazonaws.com/demo/demo-clip.mp4" />
                      {(!this.state.playing && <BigPlayButton position="center" />) || null}
                      <ControlBar autoHide={true} disableDefaultControls={true}>
                        <PlayToggle />
                      </ControlBar>
                    </Player>
                    <div className="frameCover" data-type="video" />
                  </div>
                </div>
              </div>
              <div
                className="col-lg-5 col-md-6 col-sm-6 col-xs-12  display-table"
                style={{ height: 318 }}
              >
                <div className="display-table-cell-vertical-middle">
                  <h2 className="text-dark-gray title-extra-large alt-font font-weight-600 line-height-40 sm-title-large xs-title-large margin-seven-bottom sm-margin-ten-bottom tz-text">
                    Audio snippet + branded image = Eye catching soundwave video.
                  </h2>
                  <div className="title-small sm-title-medium xs-title-medium width-90 sm-width-100 font-weight-300 margin-fourteen-bottom sm-margin-twelve-bottom tz-text">
                    Attract more listeners with a soundwave video that shows off your branding and
                    audio content. Share it on Facebook, Twitter, Instagram, LinkedIn, etc, along
                    with your audio url link.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white builder-bg  " id="portfolios-section9">
          <div className="container">
            <div className="row">
              <div className="work-3col wide gutter">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="overflow-hidden grid-gallery">
                    <div className="tab-content">
                      <ul className="masonry-items grid">
                        <li>
                          <figure>
                            <div className="">
                              <img
                                style={{ width: 375, height: 375 }}
                                src="images/soundwave-vid-demo-1.gif"
                                id=""
                                data-img-size="(W)800px X (H)650px"
                                alt="Convert Audio into Eye cathing video using Soundwise tool"
                              />
                            </div>
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <div className="">
                              <img
                                style={{ width: 375, height: 375 }}
                                src="images/soundwave-vid-demo-2.gif"
                                id=""
                                data-img-size="(W)800px X (H)650px"
                                alt="Convert Audio into Eye cathing video using Soundwise tool"
                              />
                            </div>
                          </figure>
                        </li>
                        <li>
                          <figure>
                            <div className="">
                              <img
                                style={{ width: 375, height: 375 }}
                                src="images/soundwave-vid-demo-3.gif"
                                id=""
                                data-img-size="(W)800px X (H)650px"
                                alt="Convert Audio into Eye cathing video using Soundwise tool"
                              />
                            </div>
                          </figure>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=" xs-padding-60px-tb bg-white builder-bg" id="content-section36">
          <div itemScope itemType="http://schema.org/HowTo"  className="container-fluid">
            <h2 itemProp="name"  className="section-title-large sm-section-title-medium text-dark-gray font-weight-700 alt-font margin-three-bottom xs-margin-fifteen-bottom tz-text text-center ">
              How It Works
            </h2>
                <meta itemProp="description" content="Attract more listeners with a soundwave video that shows off your branding and
                  audio content. Share it on Facebook, Twitter, Instagram, LinkedIn, etc, along
                  with your audio url link." />
                <meta itemProp="totalTime" content="P1H" />
               <meta itemProp="tool" content="Soundwise audio selling tools and services" />
               <meta itemProp="Supply" content="Audio and supplementary materials" />
            <div className="row four-column">
              <div  className="col-md-3 col-sm-6 col-xs-12 padding-six no-padding-tb sm-margin-nine-bottom xs-margin-fifteen-bottom">
              <div itemProp="step" itemScope itemType="http://schema.org/HowToSection">

                <div itemProp="name"
                  className="margin-seven-bottom xs-margin-five-bottom title-extra-large-4 alt-font tz-text font-weight-600"
                  style={{ color: Colors.mainOrange }}
                  >
                  01.
                <div itemProp="itemListElement" itemScope itemType="http://schema.org/HowToStep">
                <meta itemProp="url" content="https://mysoundwise.com/wave_video" />
                <meta itemProp="name" content="Upload audio" />
                <h3 itemProp="text" className="text-dark-gray text-extra-large alt-font display-block tz-text">
                  Upload an audio snippet from your audio course section or podcast track (under
                  {isFree ? ' 60 seconds' : ' 1 hour'})
                </h3>
                  </div>
                </div>
                </div>
                <div
                  className="separator-line2  margin-twenty-top tz-background-color"
                  style={{ background: Colors.mainOrange }}
                />
              </div>
              <div  className="col-md-3 col-sm-6 col-xs-12 padding-six no-padding-tb sm-margin-nine-bottom xs-margin-fifteen-bottom">
              <div itemProp="step" itemScope itemType="http://schema.org/HowToSection">

                <div itemProp="name"
                  className="margin-seven-bottom xs-margin-five-bottom title-extra-large-4 alt-font tz-text font-weight-600"
                  style={{ color: Colors.mainOrange }}
                  >
                  02.
                </div>
                <div itemProp="itemListElement" itemScope itemType="http://schema.org/HowToStep">
                <meta itemProp="url" content="https://mysoundwise.com/wave_video" />
                <meta itemProp="name" content="Upload image" />
                <h3  itemProp="text" className="text-dark-gray text-extra-large alt-font display-block tz-text">
                  Upload an image with information about your audio content (1080px by 1080 px or
                  1280px by 720px). You can create A pretty one easily using{' '}
                  <a
                    target="_blank"
                    style={{ color: Colors.mainGreen }}
                    href="https://www.canva.com/create/album-covers/"
                    >
                    Canva
                  </a>
                  .
                </h3>
                    </div>
                </div>
                <div
                  className="separator-line2 margin-twenty-top tz-background-color"
                  style={{ background: Colors.mainOrange }}
                />
              </div>
              <div  className="col-md-3 col-sm-6 col-xs-12 padding-six no-padding-tb sm-margin-nine-bottom xs-margin-fifteen-bottom">
              <div itemProp="step" itemScope itemType="http://schema.org/HowToSection">

                <div itemProp="name"
                  className="margin-seven-bottom xs-margin-five-bottom title-extra-large-4 alt-font tz-text font-weight-600"
                  style={{ color: Colors.mainOrange }}
                  >
                  03.
                </div>
                <div itemProp="itemListElement" itemScope itemType="http://schema.org/HowToStep">
                <meta itemProp="url" content="https://mysoundwise.com/wave_video" />
                <meta itemProp="name" content="Chose color" />
                <h3 itemProp="text" className="text-dark-gray text-extra-large alt-font display-block tz-text">
                  Pick a color and a position (top, middle, bottom) for the soundwave.
                </h3>
                </div>
                  </div>
                <div
                  className="separator-line2 margin-twenty-top tz-background-color"
                  style={{ background: Colors.mainOrange }}
                />
              </div>


              <div   className="col-md-3 col-sm-6 col-xs-12 padding-six no-padding-tb sm-margin-nine-bottom xs-margin-fifteen-bottom">
              <div itemProp="step" itemScope itemType="http://schema.org/HowToSection">

                <div itemProp="name"
                  className="margin-seven-bottom xs-margin-five-bottom title-extra-large-4 alt-font  tz-text font-weight-600"
                  style={{ color: Colors.mainOrange }}
                  >
                  04.
                </div>
                <div itemProp="itemListElement" itemScope itemType="http://schema.org/HowToStep">
                <meta itemProp="url" content="https://mysoundwise.com/wave_video" />
                <meta itemProp="name" content="Finalization" />
                <h3  itemProp="text" className="text-dark-gray text-extra-large alt-font display-block tz-text">
                  We'll create the video snippet, and when it's ready, email you a link to download
                  your video.
                </h3>
                </div>
                  </div>
                <div
                  className="separator-line2 margin-twenty-top tz-background-color"
                  style={{ background: Colors.mainOrange }}
                />
              </div>
            </div>
          </div>
        </section>
        <section
          className="padding-70px-tb xs-padding-60px-tb bg-white builder-bg"
          id="content-section36"
        >
          <div className="container-fluid">
            <h2 className="section-title-large sm-section-title-medium text-dark-gray font-weight-700 alt-font margin-three-bottom xs-margin-fifteen-bottom tz-text text-center ">
              Create A{isFree ? ' Free' : ''} Soundwave Video Clip
            </h2>
            <div className="row ">
              <div className="title-large font-weight-600 margin-three-top text-center">
                Upload audio clip (up to{isFree ? ' 1 minute' : ' 1 hour'})
                <div className="text-extra-large font-weight-400 padding-one-half-top sm-padding-two-top xs-padding-five">
                  Audio clip should be under {isFree ? ' 60 seconds' : ' 1 hour'}. mp3 and m4a files accepted.
                </div>
              </div>
              {(audioName && (
                <div
                  className="text-center margin-three-bottom margin-three-top"
                  style={{ paddingTop: 50 }}
                >
                  <div
                    className="text-center"
                    style={{ fontSize: 18 }}
                  >{`${audioName} uploaded`}</div>
                  <div
                    style={{ fontSize: 18, color: Colors.mainOrange, cursor: 'pointer' }}
                    onClick={() => this.setState({ audioName: null, audioFile: null })}
                  >
                    <strong>Cancel</strong>
                  </div>
                </div>
              )) || (
                <div
                  className="center-col col-xs-12 col-md-6 col-sm-10 text-center margin-three-bottom margin-three-top"
                  style={{ padding: '3em', backgroundColor: Colors.mainGreen }}
                >
                  <Dropzone
                    style={{ width: '100%', height: '100%' }}
                    accept="audio/mp3, audio/mpeg, audio/m4a, audio/x-m4a"
                    onDrop={this.onAudioDrop}
                  >
                    <div>
                      <div className="text-center">
                        <i className="fas fa-5x fa-volume-up" style={{ cursor: 'pointer' }} />
                      </div>
                      <div style={{ fontSize: 18, cursor: 'pointer' }}>
                        Drag your audio clip here or click to upload.
                      </div>
                    </div>
                  </Dropzone>
                </div>
              )}
              <div className="title-large font-weight-600 margin-three-bottom margin-three-top text-center">
                Upload image
                <div className="text-extra-large font-weight-400 padding-one-half-top sm-padding-two-top xs-padding-five">
                  Square image with at least 1080x1080 pixels or Rectangular image with at least 1280x720 pixels.
                </div>
              </div>
              {(this.state.cropResult && (
                <div
                  className="text-center margin-three-bottom margin-three-top"
                  style={{ verticalAlign: 'center' }}
                >
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                      style={{
                        height: 297,
                        padding: 10,
                      }}
                      src={this.state.cropResult}
                      alt="Croped thumbnail"
                    />
                  </div>
                  <div
                    style={{ fontSize: 18, color: Colors.mainOrange, cursor: 'pointer' }}
                    onClick={() =>
                      this.setState({
                        imageFile: null,
                        cropResult: null,
                      })
                    }
                  >
                    <strong>Cancel</strong>
                  </div>
                </div>
              )) || (
                <div
                  className="center-col col-xs-12 col-md-6 col-sm-10 text-center margin-three-bottom margin-three-top"
                  style={{ padding: '3em', backgroundColor: Colors.mainGreen, height: 175 }}
                >
                  <Dropzone
                    style={{ width: '100%' }}
                    accept="image/jpeg, image/png, image/jpg"
                    onDrop={this.onImageDrop}
                  >
                    <div>
                      <div className="text-center">
                        <i className="fas fa-5x fa-image" style={{ cursor: 'pointer' }} />
                      </div>
                      <div style={{ fontSize: 18, cursor: 'pointer' }}>
                        Drag your image here or click to upload.
                      </div>
                    </div>
                  </Dropzone>
                </div>
              )}
              <div
                className="center-col col-xs-12 col-md-6 col-sm-10 text-center margin-three-bottom margin-three-top"
                style={{ fontSize: 18 }}
              >
                <div className="title-large font-weight-600 margin-three-bottom margin-three-top">
                  Pick audio wave position
                </div>
                <RadioGroup
                  className="margin-three-top"
                  value={wavePosition}
                  onChange={value =>
                    this.setState({
                      wavePosition: value,
                    })
                  }
                  horizontal
                >
                  <ReversedRadioButton
                    rootColor={Colors.mainGrey}
                    pointColor={Colors.mainOrange}
                    value="bottom"
                    iconSize={20}
                  >
                    Bottom
                  </ReversedRadioButton>
                  <ReversedRadioButton
                    rootColor={Colors.mainGrey}
                    pointColor={Colors.mainOrange}
                    value="middle"
                    iconSize={20}
                  >
                    Middle
                  </ReversedRadioButton>
                  <ReversedRadioButton
                    rootColor={Colors.mainGrey}
                    pointColor={Colors.mainOrange}
                    value="top"
                    iconSize={20}
                  >
                    Top
                  </ReversedRadioButton>
                </RadioGroup>
              </div>
              <div className="center-col col-xs-12 col-md-6 col-sm-10 text-center margin-three-bottom margin-three-top">
                <div className="title-large margin-three-top margin-three-bottom font-weight-600">
                  Pick audio wave color
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <CompactPicker
                    color={waveColor}
                    onChangeComplete={color => this.setState({ waveColor: color.hex })}
                  />
                </div>
              </div>
              {(!isLoggedIn && (
                <div className="center-col col-xs-12 col-md-6 col-sm-10 text-center margin-three-bottom margin-three-top">
                  <div className="title-large margin-three-top margin-three-bottom font-weight-600">
                    Your email address
                  </div>
                  <div className="text-large margin-three-top margin-three-bottom ">
                    We'll notify you by email when your video is ready for download.
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={styles.inputTitleWrapper}>
                      <input
                        type="text"
                        style={styles.inputTitle}
                        placeholder={''}
                        onChange={e => this.setState({ email: e.target.value })}
                        value={this.state.email}
                      />
                    </div>
                  </div>
                </div>
              )) ||
                null}
              <div className="center-col col-xs-12 col-md-6 col-sm-10 text-center margin-three-bottom margin-three-top">
                {this.renderSubmitButton()}
              </div>
            </div>
          </div>
        </section>
        <Footer showPricing={true} />
      </div>
    );
  }
}

const SubmitButton = styled(BaseButton)`
  width: 229px;
`;

const styles = {
  inputTitleWrapper: { ...commonStyles.inputTitleWrapper },
  inputTitle: { ...commonStyles.inputTitle },
};

const mapStateToProps = state => {
  const { userInfo, isLoggedIn } = state.user;
  return { userInfo, isLoggedIn };
};

export const WaveVideoInputs = connect(
  mapStateToProps,
  null
)(_WaveVideoInputs);
